import { useQuery } from '@tanstack/react-query';

import { myPastDueMembersKey, requestMyPastDueMembers } from './membersApi';

/**
 * The rows of the directory's Past Due view, at the app's default staleness.
 *
 * No `Failure` variant to handle: `myPastDueMembers` is a pure read, so infrastructure errors travel
 * the standard GraphQL errors envelope, and the directory shows them as its error state.
 */
export function useMyPastDueMembers() {
  return useQuery({ queryKey: myPastDueMembersKey, queryFn: requestMyPastDueMembers });
}
